// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class ServiceRequestResource extends Resource {
    basePath: string = 'services/request/';

    objectPath: string = 'services/request/{ident}/';
}
